import { useEffect, useState } from 'react'
import type { ApiEventDay } from 'leLive/api/leLive'
import { getIcalContent, getGoogleCalendarUrl, getOutlookCalendarUrl } from 'leLive/utils/calendarUtils'

interface LeLiveCalendarLinks {
  icalBlobUrl: string | undefined
  googleCalendarUrl: string
  outlookCalendarUrl: string
}

export function useLeLiveCalendar(eventDay?: ApiEventDay): LeLiveCalendarLinks {
  const [icalBlobUrl, setIcalBlobUrl] = useState<string>()

  useEffect(() => {
    if (typeof Blob === 'undefined') return
    const content = getIcalContent(eventDay)
    const blobUrl = URL.createObjectURL(new Blob([content], { type: 'text/calendar' }))
    setIcalBlobUrl(blobUrl)
    return () => URL.revokeObjectURL(blobUrl)
  }, [eventDay])

  return {
    icalBlobUrl,
    googleCalendarUrl: getGoogleCalendarUrl(eventDay),
    outlookCalendarUrl: getOutlookCalendarUrl(eventDay),
  }
}
